function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, inputText) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'mp-tag-selector-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-tag-input", {
          "attrs": __vjadeStringifyAttrsIfObj({
            error: $attr(`error`),
            'min-tags': $attr(`min-tags`),
            saving: $attr(`saving`),
            'show-search-icon': true,
            'search-text': $helpers.searchText(),
            tags: JSON.stringify($helpers.getSelectedTagAttrs()),
          }),
          "style": {
            'max-height': $attr(`max-tag-input-height`),
          },
          "on": {
            change: $helpers.handleInputChange,
            keydown: $helpers.handleKeyDown,
          },
          "class": {
            'input-el': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-tag-selector-hr': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
          "attrs": __vjadeStringifyAttrsIfObj({
            'empty-message': $helpers.emptyText(),
            'search-filter': inputText,
            sections: JSON.stringify($helpers.getMenuSections()),
          }),
          "style": {
            'max-height': $attr(`max-tag-items-height`),
          },
          "props": {
            keydownProxyEl: $helpers.getKeydownProxyEl(),
          },
          "on": {
            clickItem: ev => $helpers.addTag(ev.detail),
          },
        }));
        __jade_nodes = __jade_nodes.concat((!$attr(`read-only`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($helpers.showCreateButton()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
              "attrs": __vjadeStringifyAttrsIfObj({
                color: `grey`
              }),
              "on": {
                click: () => $helpers.addNewTag(inputText)
              },
              "class": {
                'create-btn': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-tag-selector-create-tag-btn': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-tag-selector-copy': true
                  },
                }, [__vjadeSafeCode($helpers.createNewText())]));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-tag-selector-label-name': true
                  },
                }, [__vjadeSafeCode(inputText)]));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
              "attrs": __vjadeStringifyAttrsIfObj({
                color: `blue`,
                disabled: $attr(`saving`),
                title: `Save Tags (Alt+Enter)`
              }),
              "on": {
                click: $helpers.saveTags
              },
              "class": {
                'save-btn': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`saving`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-spinner", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    color: `white`
                  }),
                }));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Save");;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "inputText" in locals ? locals.inputText : typeof inputText !== "undefined" ? inputText : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;